import JsBarcode from 'jsbarcode';
import { DOMImplementation, XMLSerializer } from 'xmldom';
import img from '../../../assests/logo.jpg'
import blogFetch from '../../../axios/config';

export class Impressao {

  constructor(dadosParaImpressao) {
    this.dadosParaImpressao = dadosParaImpressao;
  }

  async PreparaDocumento() {
    const enderecosPorCodigo = await this.buscarEnderecosPorCodigo();
    const corpoDocumento = this.CriaCorpoDocumento(enderecosPorCodigo);
    const documento = await this.GerarDocumento(corpoDocumento);
    return documento;
  }

  // Para cada código de molde do vagão, busca todos os endereços (SAP Local)
  // onde aquele código existe em estoque/reservado.
  async buscarEnderecosPorCodigo() {
    const codigos = Array.from(new Set(
      this.dadosParaImpressao.moldsWagon
        .map(({ mold }) => mold.molde_Codigo)
        .filter(Boolean)
    ));

    const mapa = {};
    await Promise.all(codigos.map(async (codigo) => {
      try {
        const { data } = await blogFetch.get(
          `/ISAGA_Moldes/listMolds?search=${codigo}&skip=0&take=200`
        );
        mapa[codigo] = Array.from(new Set(
          (data?.molds ?? [])
            .filter((m) => String(m.molde_Codigo) === String(codigo))
            .map((m) => m.molde_SAPLocal)
            .filter((e) => e && e !== 'NÃO CADASTRADO')
        ));
      } catch (e) {
        mapa[codigo] = [];
      }
    }));

    return mapa;
  }

  gerarBarcodeSvg(code) {
    const xmlSerializer = new XMLSerializer();
    const document = new DOMImplementation().createDocument('http://www.w3.org/1999/xhtml', 'html', null);
    const svgNode = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

    JsBarcode(svgNode, code, {
      xmlDocument: document,
      width: 2,
      height: 50,
      fontSize: 16,
      margin: 0,
      displayValue: true,
    });

    return xmlSerializer.serializeToString(svgNode);
  }

  CriaCorpoDocumento(enderecosPorCodigo = {}) {
    const wagon = this.dadosParaImpressao.wagon;
    const combinacao = this.dadosParaImpressao.typesPiecesCombinations;

    const moldsValidos = this.dadosParaImpressao.moldsWagon.filter(({ mold, piece }) => {
      const filtrado = wagon?.isagA_Vagoes_Fornos_Pecas?.some(
        w => (w.ordem_Serial === piece.ordem_Serial && !w.ativo) || mold.molde_Status === "INDISPONIVEL"
      );
      return !filtrado;
    });

    const linhas = moldsValidos.map(({ mold, piece }) => ({
      mold,
      piece,
      ultima: mold.molde_QtdPassagens + 1 === mold.molde_QtdPassagensMAX,
    }));

    const formatMetragem = (p) => (p.m2_Peca != null && p.m2_Peca !== '' ? `${p.m2_Peca} m²` : '—');

    // Cabeçalho com dados do vagão
    const cabecalhoVagao = {
      layout: 'noBorders',
      margin: [0, 0, 0, 10],
      table: {
        widths: ['*', '*', '*'],
        body: [
          [
            { text: 'VAGÃO', bold: true, fontSize: 9, color: '#666666' },
            { text: 'FORNO', bold: true, fontSize: 9, color: '#666666' },
            { text: 'COMBINAÇÃO', bold: true, fontSize: 9, color: '#666666' },
          ],
          [
            { text: wagon.vagao_Serial ?? '', fontSize: 18, bold: true },
            { text: combinacao?.forno ?? '', fontSize: 18, bold: true },
            { text: combinacao?.comb_Nome ?? '', fontSize: 14, bold: true },
          ],
        ],
      },
    };

    // Endereços (SAP Local) de cada molde: junta o endereço da reserva com
    // todos os demais locais onde o mesmo código existe em estoque.
    const enderecosDoMolde = (mold) => Array.from(new Set(
      [mold.molde_SAPLocal, ...(enderecosPorCodigo[mold.molde_Codigo] ?? [])]
        .filter((e) => e && e !== 'NÃO CADASTRADO')
    ));

    const tituloTabela = {
      text: 'ORDENS DO VAGÃO',
      fontSize: 11,
      bold: true,
      color: '#666666',
      margin: [0, 0, 0, 4],
    };

    const cabecalhoTabela = [
      { text: 'Ordem', bold: true, fontSize: 10, color: '#555555' },
      { text: 'Peça', bold: true, fontSize: 10, color: '#555555' },
      { text: 'Produto / Veículo', bold: true, fontSize: 10, color: '#555555' },
      { text: 'M²', bold: true, fontSize: 10, color: '#555555', alignment: 'right' },
      { text: 'Molde', bold: true, fontSize: 10, color: '#555555' },
      { text: 'Lote', bold: true, fontSize: 10, color: '#555555' },
      { text: 'Descrição', bold: true, fontSize: 10, color: '#555555' },
      { text: 'Endereço', bold: true, fontSize: 10, color: '#555555' },
      { text: 'Pass.', bold: true, fontSize: 10, color: '#555555', alignment: 'center' },
      { text: 'Últ.', bold: true, fontSize: 10, color: '#555555', alignment: 'center' },
    ];

    const corpoTabela = linhas.map(({ mold, piece, ultima }) => [
      { text: piece.ordem_Serial ?? '', fontSize: 11, bold: true },
      { text: piece.ordem_Part_Short ?? '', fontSize: 11 },
      {
        stack: [
          { text: piece.subProduto_Desc ?? '', fontSize: 10 },
          {
            text: [piece.ordem_VehCod, piece.ordem_VehDesc].filter(Boolean).join(' · '),
            fontSize: 9,
            color: '#777777',
          },
        ],
      },
      { text: formatMetragem(piece), fontSize: 11, alignment: 'right' },
      { text: mold.molde_Codigo ?? '', fontSize: 11, bold: true },
      { text: mold.molde_Lote ?? '', fontSize: 11 },
      { text: mold.molde_Descricao ?? '', fontSize: 10 },
      { text: enderecosDoMolde(mold).join(', ') || '—', fontSize: 13, bold: true },
      {
        text: `${mold.molde_QtdPassagens ?? 0}/${mold.molde_QtdPassagensMAX ?? 0}`,
        fontSize: 11,
        alignment: 'center',
      },
      ultima
        ? {
            text: '⚠ SIM',
            fontSize: 11,
            bold: true,
            color: '#c0392b',
            alignment: 'center',
            link: `sagaprintserver:BR_Molde;SAGA_User;${mold.molde_Codigo}`,
          }
        : { text: '—', fontSize: 11, alignment: 'center', color: '#999999' },
    ]);

    const tabelaMoldes = {
      layout: {
        hLineWidth: (i) => (i === 0 || i === 1 ? 0.8 : 0.3),
        vLineWidth: () => 0,
        hLineColor: () => '#cccccc',
        fillColor: (rowIndex) => {
          if (rowIndex === 0) return null;
          const linha = linhas[rowIndex - 1];
          if (linha?.ultima) return '#ffe0cc';
          return rowIndex % 2 === 0 ? '#f7f7f7' : null;
        },
        paddingTop: () => 7,
        paddingBottom: () => 7,
        paddingLeft: () => 5,
        paddingRight: () => 5,
      },
      table: {
        headerRows: 1,
        widths: ['auto', 'auto', '*', 'auto', 'auto', 'auto', '*', 'auto', 'auto', 'auto'],
        body: [cabecalhoTabela, ...corpoTabela],
      },
    };

    const temUltimaPassagem = linhas.some(({ ultima }) => ultima);
    const legenda = {
      text: '⚠ SIM = última passagem deste molde',
      fontSize: 8,
      italics: true,
      color: '#c0392b',
      margin: [0, 8, 0, 0],
    };

    const codigoBarras = {
      svg: this.gerarBarcodeSvg(wagon.vagao_Serial ?? '0'),
      alignment: 'center',
      margin: [0, 14, 0, 0],
    };

    const conteudo = [cabecalhoVagao, tituloTabela, tabelaMoldes];
    if (temUltimaPassagem) conteudo.push(legenda);
    conteudo.push(codigoBarras);
    return conteudo;
  }

  GetBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };

      img.onerror = error => {
        reject(error);
      };

      img.src = url;
    });
  }

  async GerarDocumento(content) {
    const dataImpressao = new Date().toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });

    const documento = {
      pageSize: 'A4',
      pageMargins: [30, 60, 30, 40],
      header: function () {
        return {
          margin: [20, 16, 20, 0],
          layout: 'noBorders',
          table: {
            widths: ['*'],
            body: [
              [
                {
                  text: 'PREPARAÇÃO DE VAGÔES',
                  bold: true,
                  fontSize: 18,
                  alignment: 'center',
                },
              ],
            ],
          },
        };
      },

      content,

      images: {
        snow: await this.GetBase64ImageFromURL(img),
      },

      footer(currentPage, pageCount) {
        return {
          layout: 'noBorders',
          margin: [20, 0, 20, 16],
          table: {
            widths: ['*', '*', '*'],
            body: [
              [
                {
                  text: `Impresso em ${dataImpressao}`,
                  fontSize: 8,
                  alignment: 'left',
                },
                {
                  text: '© AGP Brasil',
                  fontSize: 8,
                  alignment: 'center',
                },
                {
                  text: `Página ${currentPage.toString()} de ${pageCount}`,
                  fontSize: 8,
                  alignment: 'right',
                },
              ],
            ],
          },
        };
      },
    };

    return documento;
  }
}
